module.exports = __webpack_public_path__ + "static/coomon-good-solutoins-logo-3180a76bbb52fc59f60f7baf62e21491.png";